const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

export function nextIsoDate(value) {
  if (!ISO_DATE.test(String(value || ""))) return "";
  const date = new Date(`${value}T00:00:00.000Z`);
  if (Number.isNaN(date.getTime()) || date.toISOString().slice(0, 10) !== value) {
    return "";
  }
  date.setUTCDate(date.getUTCDate() + 1);
  return date.toISOString().slice(0, 10);
}

export function displayedTrancheStart(tranches, index) {
  const current = tranches[index];
  const previous = tranches[index - 1];
  if (previous && previous.to === current?.from) {
    return nextIsoDate(current.from);
  }
  return current?.from || "";
}
